module.exports = __webpack_public_path__ + "./img/OfertasArticulos.2406283085ebfdf2d9b70cddebc3df40.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/OfertasArticulos.png
// module id = ./public/img/Help/OfertasArticulos.png
// module chunks = 0